"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReduxEnhancer = exports.setUser = exports.getSentryConfig = exports.isHoneyIssue = exports.initMonitoring = void 0;
var Sentry = __importStar(require("@sentry/react"));
var ignoreConfig_1 = __importDefault(require("./ignoreConfig"));
// See https://github.com/getsentry/sentry-javascript/issues/2175
var isHoneyIssue = function (event) {
    var e_1, _a;
    if (!event.breadcrumbs) {
        return false;
    }
    try {
        for (var _b = __values(event.breadcrumbs), _c = _b.next(); !_c.done; _c = _b.next()) {
            var breadcrumb = _c.value;
            if (breadcrumb &&
                breadcrumb.message &&
                breadcrumb.message.includes &&
                breadcrumb.message.includes('div#honeyContainer')) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
};
exports.isHoneyIssue = isHoneyIssue;
var getSentryConfig = function (sentryProject, options) {
    var beforeSend;
    if (options) {
        beforeSend = options.beforeSend;
        delete options.beforeSend;
    }
    return __assign(__assign(__assign({}, ignoreConfig_1.default), { release: sentryProject + "@" + (process.env.APP_VERSION || 'unknown'), beforeSend: function (event) {
            if (isHoneyIssue(event)) {
                return null;
            }
            if (beforeSend) {
                return beforeSend(event);
            }
            return event;
        } }), options);
};
exports.getSentryConfig = getSentryConfig;
/**
 * [initMonitoring description]
 * Function that sets up Sentry for your application. You can
 * override any setting, but you'll need to provide the DSN of the
 * application, which is the identifier Sentry uses to send the errors
 * to the correct dashboard
 */
var initMonitoring = function (sentryProject, options, enableInDev) {
    if (enableInDev === void 0) { enableInDev = false; }
    var sentryConfig = getSentryConfig(sentryProject, options);
    var env = process.env.NODE_ENV || 'development';
    if (enableInDev || env !== 'development') {
        Sentry.init(sentryConfig);
    }
};
exports.initMonitoring = initMonitoring;
/**
 * [setUser description]
 * Function to set the user context for your sentry application.
 * https://docs.sentry.io/platforms/javascript/enriching-events/identify-user/
 */
var setUser = function (user) {
    Sentry.configureScope(function (scope) {
        scope.setUser(user);
    });
};
exports.setUser = setUser;
/**
 * [createReduxEnhancer description]
 * Function to enhance sentry errors with information from redux.
 * Currently disabling the sending of state by default
 * and only sending the action type to prevent leaking of PII.
 */
function createReduxEnhancer(enhancerOptions) {
    var options = __assign({ actionTransformer: (enhancerOptions && enhancerOptions.actionTransformer) ||
            (function (action) { return ({ type: action.type }); }), stateTransformer: (enhancerOptions && enhancerOptions.stateTransformer) || (function () { return null; }) }, enhancerOptions);
    return Sentry.createReduxEnhancer(options);
}
exports.createReduxEnhancer = createReduxEnhancer;
